export const desktopDefaultSize = 14;
export const tabletDefaultSize = 14;
export const mobileDefaultSize = 14;
const fallbackFontFamilies =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
export const normalFontFamily = `Work Sans, ${fallbackFontFamilies}`;
export const normalVariableFontFamily = `Work SansVariable, ${fallbackFontFamilies}`;
export const headerFontFamily = `Work Sans, ${fallbackFontFamilies}`;
export const headerVariableFontFamily = `Work SansVariable, ${fallbackFontFamilies}`;
